<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="callout callout-info" v-if="formLoan.bir=='Y'">
                    <p class="bold fs-18">With BIR-Filed Financial Statement</p>
                    <div class="table-responsive text-center">
                        <table class="table table-sm table-striped table-bordered table-middle">
                            <thead>
                                <tr>
                                    <th>Size of Enterprise</th>
                                    <th>Asset Size</th>
                                    <th>Maximum Loanable Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Micro</td>
                                    <td>up to PhP3.0 million</td>
                                    <td>PhP600.0 thousand</td>
                                </tr>
                                <tr>
                                    <td>Small</td>
                                    <td>not to exceed PhP15.0 million</td>
                                    <td>PhP3.0 million</td>
                                </tr>
                                <tr>
                                    <td>Medium</td>
                                    <td>exceeding PhP15.0 million and up to PhP100.0 million</td>
                                    <td>PhP5.0 million</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <em><b>* Not to exceed 15% of Sales and 20% of Asset Size</b></em>
                </div>

                <div class="callout callout-info" v-if="formLoan.bir=='N'">
                    <p class="bold fs-18">Without BIR-Filed Financial Statement</p>
                    <div class="row">
                        <div class="col-sm-6 col-12">
                            <div class="table-responsive text-center">
                                <table class="table table-sm table-striped table-bordered table-middle">
                                    <thead>
                                        <tr>
                                            <th>Asset Size</th>
                                            <th>Maximum Loanable Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>At least PhP50.0 thousand</td>
                                            <td>PhP10.0 thousand</td>
                                        </tr>
                                        <tr>
                                            <td>At least PhP100.0 thousand</td>
                                            <td>PhP20.0 thousand</td>
                                        </tr>
                                        <tr>
                                            <td>At least PhP200.0 thousand</td>
                                            <td>PhP40.0 thousand</td>
                                        </tr>
                                        <tr>
                                            <td>At least PhP300.0 thousand</td>
                                            <td>PhP60.0 thousand</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-sm-6 col-12">
                            <div class="table-responsive text-center">
                                <table class="table table-sm table-striped table-bordered table-middle">
                                    <thead>
                                        <tr>
                                            <th>Asset Size</th>
                                            <th>Maximum Loanable Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>At least PhP400.0 thousand</td>
                                            <td>PhP80.0 thousand</td>
                                        </tr>
                                        <tr>
                                            <td>At least PhP500.0 thousand</td>
                                            <td>PhP100.0 thousand</td>
                                        </tr>
                                        <tr>
                                            <td>At least PhP750.0 thousand</td>
                                            <td>PhP150.0 thousand</td>
                                        </tr>
                                        <tr>
                                            <td>PhP1.0 million and above</td>
                                            <td>PhP200.0 thousand</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Well done, you may now provide your preferred loan amount</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 alert alert-success2">
                                <p class="card-text text-justify pb-0 mb-0">NOTE: Requested loan amount is subject to assessment and approval by SB Corporation</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Loan Amount</label>
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                        </div>
                                        <input v-if="req_loan_amt" @blur="req_loan_amt=false, checkLoanAmount()" @paste.prevent @keypress="maxNum($event)" type="number" class="form-control" v-model="formLoan.req_loan_amt" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_amt.$error}">
                                        <input v-else @focus="req_loan_amt=true" type="text" class="form-control" :value="formLoan.req_loan_amt ? $options.filters.curr(formLoan.req_loan_amt) : null" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_amt.$error}">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Loan Term (in months) (inclusive of grace period)</label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.req_loan_term" @change="serviceFee" :class="{'is-invalid': $parent.submitting && $v.formLoan.req_loan_term.$error}">
                                        <option :value='null' disabled>- Select -</option>
                                        <option value="6">6</option>
                                        <option value="12">12</option>
                                        <option value="18">18</option>
                                        <option value="24">24</option>
                                        <option value="30">30</option>
                                        <option value="36">36</option>
                                        <option value="42" v-if="formLoan.req_loan_amt > 100000 || formLoan.loan_bus_code=='FIB03'">42</option>
                                        <option value="48" v-if="formLoan.req_loan_amt > 100000 || formLoan.loan_bus_code=='FIB03'">48</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" v-if="formLoan.loan_bus_code=='FIB03'">
                                    <label>Grace Period (in months)</label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.grace_period" @change="installFee" :class="{'is-invalid': $parent.submitting && $v.formLoan.grace_period.$error}">
                                        <option :value='null' disabled>- Select -</option>
                                        <option value="0">0</option>
                                        <option value="3">3</option>
                                        <option v-if="formLoan.req_loan_term >= 12" value="6">6</option>
                                        <option v-if="formLoan.req_loan_term >= 18" value="9">9</option>
                                        <option v-if="formLoan.req_loan_term >= 24" value="12">12</option>
                                        <option v-if="formLoan.req_loan_term >= 30" value="15">15</option>
                                        <option v-if="formLoan.req_loan_term >= 36" value="18">18</option>
                                        <option v-if="formLoan.req_loan_term >= 42" value="21">21</option>
                                        <option v-if="formLoan.req_loan_term >= 48" value="24">24</option>
                                    </select>
                                </div>
                                <div class="form-group" v-else>
                                    <label>Grace Period (in months)</label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.grace_period" @change="installFee" :class="{'is-invalid': $parent.submitting && $v.formLoan.grace_period.$error}">
                                        <option :value='null' disabled>- Select -</option>
                                        <option value="0">0</option>
                                        <option value="3">3</option>
                                        <option v-if="formLoan.req_loan_term >= 12" value="6">6</option>
                                        <option v-if="formLoan.req_loan_term >= 18" value="9">9</option>
                                        <option v-if="formLoan.req_loan_term >= 24" value="12">12</option>
                                        <option v-if="formLoan.req_loan_term >= 30" value="24">24</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Service Fee</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.service_fee" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Installment Period (in months)</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.install_fee" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Payment Mode</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.monthly='Monthly'" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {
                readonly: true,
                req_loan_amt: false,
            }
        },
        validations: {
            formLoan: {
                req_loan_amt: {
                    required
                },
                req_loan_term: {
                    required
                },
                grace_period: {
                    required
                },
            },
        },
        created() {},
        methods: {

            next() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;
                this.$v.formLoan.$touch();
                if (this.$v.formLoan.$invalid) {} else {
                    this.$emit('next');
                }
            },
            thousands_separators(num) {
                if (num) {
                    let num_parts = num.toString().split(".");
                    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return num_parts.join(".");
                }
            },
            checkLoanAmount() {
                let val = this.formLoan.req_loan_amt;
                let loanAmount = this.formLoan.req_loan_amt * 1;
                let maxLoan = this.formLoan.max_loan;
                let amount = this.thousands_separators(maxLoan);

                if (loanAmount) {
                    if (loanAmount < 10000) {
                        Swal.fire({
                            icon: 'info',
                            title: 'Reminder',
                            html: `Minimum Loan: <b>Php 10,000</b>`,
                            allowOutsideClick: false
                        }).then((response) => {
                            this.formLoan.req_loan_amt = null;
                            this.formLoan.req_loan_term = null;
                            this.formLoan.grace_period = null;
                            this.formLoan.service_fee = null;
                            this.formLoan.install_fee = null;
                        })
                    } else {
                        if (loanAmount > maxLoan) {
                            Swal.fire({
                                icon: 'info',
                                title: 'Reminder',
                                html: `Maximum Loan: <b>Php ${amount}</b>`,
                                allowOutsideClick: false
                            }).then((response) => {
                                this.formLoan.req_loan_amt = null;
                                this.formLoan.req_loan_term = null;
                                this.formLoan.grace_period = null;
                                this.formLoan.service_fee = null;
                                this.formLoan.install_fee = null;
                            })
                        }
                    }
                } else {
                    this.formLoan.req_loan_term = null;
                    this.formLoan.grace_period = null;
                    this.formLoan.service_fee = null;
                    this.formLoan.install_fee = null;
                }

            },
            serviceFee() {
                this.formLoan.grace_period = null;
                this.formLoan.install_fee = null;
                if (this.formLoan.req_loan_term == 6 || this.formLoan.req_loan_term == 12) {
                    this.formLoan.service_fee = "4.0%"
                } else if (this.formLoan.req_loan_term == 18 || this.formLoan.req_loan_term == 24) {
                    this.formLoan.service_fee = "6.0%"
                } else if (this.formLoan.req_loan_term == 30 || this.formLoan.req_loan_term == 36) {
                    this.formLoan.service_fee = "7.5%"
                } else if (this.formLoan.req_loan_term == 42 || this.formLoan.req_loan_term == 48) {
                    this.formLoan.service_fee = "8.0%"
                } else {}
            },
            installFee() {
                if (this.formLoan.grace_period) {
                    let term = this.formLoan.req_loan_term * 1;
                    let grace = this.formLoan.grace_period * 1;
                    this.formLoan.install_fee = term - grace;
                }
            },
            maxNum(e) {
                let val = e.target.value;
                if (e.keyCode === 46) { //dot
                    e.preventDefault();
                } else {
                    if (val.length <= 6) {
                        this.formLoan.req_loan_term = null;
                        this.formLoan.grace_period = null;
                        this.formLoan.service_fee = null;
                        this.formLoan.install_fee = null;
                        return true;
                    } else e.preventDefault();
                }
            },
            handler($event) {
                if (this.readonly) {
                    $event.preventDefault();
                }
            },
        },
        computed: {

        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>